 import servise from '@/router/axios'
 import qs from 'qs'
//获取点击行为报表
export const getClickList = (params)=>{
    return servise({
        url:'/clk/behavior/list',
        params
    })
}
//获取点击行为报表csv
export const getClkCsv = (params)=>{
    return process.env.VUE_APP_BASE_API  + '/clk/behavior/csv?' + qs.stringify(params)
}